import Loadable from "@/components/Loadable";
import { lazy } from "react";
import BlanckLayout from "../layout/BlankLayout";

const CheckoutApp = Loadable(
  lazy(() => import("@/pages/common/checkout/CheckoutApp"))
);

const CheckoutAppRoutes = {
  path: "checkout-app",
  element: <BlanckLayout />,
  children: [
    {
      path: "pagamento/:idRequest/:token/",
      element: <CheckoutApp />,
    },
  ],
};

export default CheckoutAppRoutes;
